<template>
<!-- 两会头图 -->
<!--  <div class="app_content" :class="[showFilter?'htmlFilter':'']" style="background: url('https://hfy-img.xzyunchuang.com/3f3d35ba917a4ae0b38cd0dce750bb97.png') no-repeat center top;padding-top: 350px;">-->
  <div class="app_content" :class="[showFilter?'htmlFilter':'']">
<!--  两会按钮  -->
<!--    <p class="enterZ">-->
<!--      <a href="https://www.cnxz.com.cn/topList?topic=749" target="_blank" style="cursor: pointer">-->
<!--        <img src="https://hfy-img.xzyunchuang.com/1896838018255392768.png"/>-->
<!--      </a>-->
<!--    </p>-->
<!--  两会留白  -->
<!--    <div class="pageW"  style="background: #fff; padding: 15px">-->
    <div class="pageW">
      <indexBannerTop :bannerData="bannerData"></indexBannerTop>
      <!-- 头部 -->
      <indexTab></indexTab>
      <!-- 重要新闻 -->
      <div class="import_tit_1" v-if="indexTopList && indexTopList.presidentTop">
        <a @click="goDetailNew(indexTopList.presidentTop)">
          <span>{{ indexTopList.presidentTop.title }}</span>
        </a>
        <p @click="goImport"><span>更多头条</span></p>
      </div>
      <div class="import_tit_2" v-if="indexTopList && indexTopList.presidentList">
        <a @click="goDetailNew(item)" v-for="(item, index) in indexTopList.presidentList" :key="index">
          [{{ item.title }}]
        </a>
      </div>
      <!-- banner及重要人物 -->
      <div class="banner">
        <div class="banner_l">
          <div class="banner_l_tit" v-if="bannerDataList">
            <ul ref="bannerL">
              <li class="overf" @click="goDetailNew(item)" v-for="(item, index) in bannerDataList" :key="index">
                {{ item.title }}
              </li>
            </ul>
          </div>
          <el-carousel v-if="indexTopList && indexTopList.indexBanner" :autoplay="true" class="banner_car" :interval="6000">
            <el-carousel-item v-for="(item, index) in indexTopList.indexBanner" :key="index">
              <img @click="goDetailNew(item)" :src="item.imgUrl" />
              <div @click="goDetailNew(item)" class="overf banner_car_tit" style="padding-right: 120px;">
                {{ item.title }}
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="banner_r" v-if="indexTopList && indexTopList.newsTop && indexTopList.newsList">
          <p class="banner_r_p" style="justify-content: center">
<!--            <img @click="goDetail('/topicSpacil', '宋乐伟')"-->
<!--              src="http://hfy-img.xzyunchuang.com/04e3711a4de4d248dd717a94edc5a7cf" />-->
            <img @click="goDetail('/topicSpacil', '宋乐伟')"
                 src="https://hfy-img.xzyunchuang.com/upload/20250623/45b59c369b819e96083582f147115986.jpg" />
<!--                 src="https://hfy-img.xzyunchuang.com/1750296483341undefined" />-->
          </p>
          <p class="banner_r_p" style="justify-content: center">
<!--            <img @click="goDetail('/topicSpacil', '宋乐伟')"-->
<!--                 src="http://hfy-img.xzyunchuang.com/04e3711a4de4d248dd717a94edc5a7cf" />-->
            <img @click="goDetail('/topicSpacil', '沈峻峰')"
                 src="https://hfy-img.xzyunchuang.com/upload/20250623/a401ff2dccf9c3ef1a339ed321943e0c.jpg" />
<!--                 src="https://hfy-img.xzyunchuang.com/1750296483341undefined" />-->
            <!--            <img @click="goDetail('/topicSpacil', '王剑锋')"-->
            <!--              src="http://hfy-img.xzyunchuang.com/18aa681f18f9bc923e8c257f46964a0e" />-->
          </p>
          <ul class="banner_r_ul newsUl newsUlT">
            <li class="overf" @click="goDetailNew(indexTopList.newsTop)">
              {{ indexTopList.newsTop.title }}
            </li>
            <li @click="goDetailNew(item)" v-for="(item, index) in indexTopList.newsList" :key="index">
              <span class="overf"> {{ item.title }}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 中间图片 -->
      <indexBannerCenter :bannerData="bannerData"></indexBannerCenter>
      <!-- 内容 -->
      <div class="news">
        <div class="news_content">
          <div v-if="columnNewData && columnNewData.length > 3">
            <div class="new_ul" v-for="(item, index) in columnNewData.slice(0, 4)" :key="index">
              <p @click="goRouter(item.columnId)">{{ item.columnName }}</p>
              <ul class="newsUl" v-if="item.articleList">
                <li @click="goDetailNew(item1)" v-for="(item1, index1) in item.articleList.slice(0, 10)" :key="index1">
                  <span class="overf"> {{ item1.title }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div v-else class="loadingInfo">
            <img src="http://hfy-img.xzyunchuang.com/a64cc6ed942b4fbd676693a5fa7241f5" />
            <p>正在努力加载中……</p>
          </div>
        </div>
        <div class="news_r">
          <p class="news_r_tit">
            <span>数字报</span>
            <img src="http://hfy-img.xzyunchuang.com/01f8165ab7c2d34a3c57a9e9417d8384" />
          </p>
          <div v-if="shuzi" class="new_r_card new_r_shu">
            <a v-if="shuzi.xzrb" :href="shuzi.xzrb.url" target="_blank">
              <img :src="shuzi.xzrb.img" />
              <p>徐州日报 </p>
            </a>
            <a v-if="shuzi.dscb" :href="shuzi.dscb.url" target="_blank">
              <img :src="shuzi.dscb.img" />
              <p>都市晨报</p>
            </a>
          </div>
          <p class="news_r_tit">
            <span @click="gofabuIm()">微信</span>
            <img src="http://hfy-img.xzyunchuang.com/01f8165ab7c2d34a3c57a9e9417d8384" />
          </p>
          <div v-if="columnNewData && columnNewData[4]" class="new_r_card">
            <div class="newsList" @click="goDetailNew(item)"
              v-for="(item, index) in columnNewData[4].articleList.slice(0, 2)" :key="index">
              <img :src="item.imgUrl?item.imgUrl:'http://hfy-img.xzyunchuang.com/dbde6d9279a88d33f1b8fdec75a549a2'" data-src=""/>
              <div>
                <p class="overf">{{ item.title }}</p>
                <p>{{ item.publishDate }}</p>
              </div>
            </div>

          </div>
          <p class="news_r_tit">
            <span>微博</span>

            <img src="http://hfy-img.xzyunchuang.com/01f8165ab7c2d34a3c57a9e9417d8384" />
          </p>
          <div class="new_r_card new_r_cards" style="">
            <!-- <embed width="100%" height="550"  class="share_self" scrolling="no" src="//widget.weibo.com/weiboshow/index.php?language=&width=0&height=550&fansRow=2&ptype=1&speed=0&skin=1&isTitle=1&noborder=1&isWeibo=1&isFans=1&uid=2606405674&verifier=d5cf5ffc&dpc=1">
            </embed> -->
            <object
              data="https://widget.weibo.com/weiboshow/index.php?language=&width=0&height=540&fansRow=1&ptype=1&speed=0&skin=1&isTitle=1&noborder=1&isWeibo=1&isFans=0&uid=3514316985&verifier=06ea50e8&dpc=1"
              width="100%" height="550" type="text/html">
            </object>
          </div>
        </div>
      </div>
      <!-- 专题 -->
      <div class="topic">
        <img class="topicImg" src="http://hfy-img.xzyunchuang.com/00721c7d8ac288aa8a73992c3e6799dd" />
        <div class="topicList">
          <topicIcon :topicData="topicData"></topicIcon>
        </div>
      </div>
      <!-- 底部腰线 -->
      <indexBannerBottom :bannerData="bannerData"></indexBannerBottom>
      <!-- 徐州发布视频 -->
      <div class="videoList" v-for="(item, index) in otherNewsData" :key="index">
        <p><span @click="goXuZ(item.columnName)">{{ item.columnName }}</span></p>
        <ul v-if="item.articleList.length > 0">
          <li v-for="(item1, index1) in item.articleList.slice(0, 4)" :key="index1" @click="goFabu(item1, index)">
            <a :href="item1.jumpLink" target="_blank">
              <img :src="item1.imgUrl" />
              <img class="videoPlay" src="http://hfy-img.xzyunchuang.com/3cce897a38d5c9a9ff6b18c8cb4bfec9" />
              <span class="overf">{{ item1.title }}</span>
            </a>
          </li>
        </ul>
        <ul v-else>
          <li v-for="(item1, index1) in index == 0 ? xzfbs : xzws" :key="index1">
            <a :href="item1.jumpLink" target="_blank">
              <img :src="item1.imgUrl" />
              <img class="videoPlay" src="http://hfy-img.xzyunchuang.com/3cce897a38d5c9a9ff6b18c8cb4bfec9" />
              <span class="overf">{{ item1.title }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 背景 -->
    <div class="wxBg ">
      <div class="pageW">
        <p class="codeTit">了解更多徐州信息，请关注徐州新媒体官方账号</p>
        <div class="code_list">
          <div class="code_list_1" v-for="(item, index) in codeList" :key="index">
            <img :src="item.imgUrl" />
            <div>
              <p>{{ item.name }}</p>
              <p>
                <span>{{ item.sorce }}</span>
                <span>{{ item.sorce1 }}</span>
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- 网淘 -->
    <div class="onlineBg">
      <div class="pageW">
        <div class="online_c" v-if="friendshipLink[0] && friendshipLink[0].list">
          <p>中央媒体</p>
          <div>
            <span v-for="(item, index) in friendshipLink[0].list" :key="index">
              <a :href="item.url" target="_blank"> {{ item.name }}</a>
            </span>
          </div>
        </div>
        <div class="online_c" v-if="friendshipLink[1] && friendshipLink[1].list">
          <p>江苏媒体</p>
          <div>
            <span v-for="(item, index) in friendshipLink[1].list" :key="index">
              <a :href="item.url" target="_blank"> {{ item.name }}</a>
            </span>
          </div>
        </div>
        <div class="online_c" v-if="friendshipLink[2] && friendshipLink[2].list">
          <p>友情链接</p>
          <span v-for="(item, index) in friendshipLink[2].list" :key="index">
            <a :href="item.url" target="_blank"> {{ item.name }}</a>
          </span>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bot></bot>
    <slideCode :bannerData="bannerData"></slideCode>
  </div>
</template>

<script>
// 局部引入插件
import {
  indexPaper, indexAdList, friendshipLinkList,
  indexNews,//首页新闻
  indexColumnNews,//栏目新闻
  topTopic,//专题推荐
  otherNews,//发布往视
  showGray//置灰
} from "@/api/index.js";
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import slideCode from "./slideCode.vue"
import topicIcon from "./topicIcon.vue"
import indexBannerTop from "./indexBannerTop.vue"
import indexBannerCenter from "./indexBannerCenter.vue"
import indexBannerBottom from "./indexBannerBottom.vue"

export default {
  name: 'Index',
  components: {
    topicIcon,
    slideCode,
    indexBannerTop,
    indexBannerCenter,
    indexBannerBottom
  },
  data() {
    return {
      bannerDataList: [],
      bannerData: [], //轮播上面的头条
      indexTopList: {},//首页上面数据
      shuzi: {},//数字报
      adList: {},//广告位
      friendshipLink: {},//底部外链列表
      columnNewData: {},//新闻栏目
      topicData: [],//专题
      otherNewsData: [],//发布网视
      showFilter:false,
      codeList: [
        {
          name: '徐州发布微信',
          imgUrl: 'http://hfy-img.xzyunchuang.com/fc1025fd58153b9b00ea1ee7add70660',
          sorce: '微信号',
          sorce1: 'xzfb85690317'
        },
        {
          name: '徐州发布微博',
          imgUrl: 'http://hfy-img.xzyunchuang.com/b84206b93d6a69c50d4982aa8d75dcbf',
          sorce: '微博号',
          sorce1: '@徐州发布'
        },
        {
          name: '徐州日报微信',
          imgUrl: 'http://hfy-img.xzyunchuang.com/0b9c088a067230f726293536529078eb',
          sorce: '微信号',
          sorce1: 'xzrbwx'
        },
        {
          name: '汉风号APP',
          imgUrl: 'http://hfy-img.xzyunchuang.com/79183b64e63af3254cc6013082db8cd1',
          sorce: '',
          sorce1: ' 苹果安卓'
        },
        {
          name: '汉风号抖音',
          imgUrl: 'http://hfy-img.xzyunchuang.com/7b5e6fc27dc9dade252026406221f737',
          sorce: '',
          sorce1: '@苹果安卓'
        },
      ],
      xzfbs: [
        {
          imgUrl: '//www.xuzhoufabu.com/UpLoadFiles/image/20240805/20240805110647914791.jpg',
          title: '徐州药价通”上线情况新闻发..',
          jumpLink: 'http://www.xuzhoufabu.com/html/2024/202408059709.shtml'
        },
        {
          imgUrl: '//www.xuzhoufabu.com/UpLoadFiles/image/20240723/20240723103426292629.jpg',
          title: '徐州市云龙湖景区生物多样性调..',
          jumpLink: 'http://www.xuzhoufabu.com/html/2024/202407239706.shtml'
        },
        {
          imgUrl: '//www.xuzhoufabu.com/UpLoadFiles/image/20240710/20240710142442364236.jpg',
          title: '2024年“数据要素×”大赛..',
          jumpLink: 'http://www.xuzhoufabu.com/html/2024/202407109702.shtml'
        },
        {
          imgUrl: '//www.xuzhoufabu.com/UpLoadFiles/image/20240627/2024062710510885885.jpg',
          title: '徐州市“医保t指数”考评和通..',
          jumpLink: 'http://www.xuzhoufabu.com/html/2024/202406279699.shtml'
        }
      ],
      xzws: [
        {
          imgUrl: '//video.cnxz.com.cn/UpLoadFiles/image/20240520/20240520151726912691.png',
          title: '文脉里的新徐州',
          jumpLink: 'http://video.cnxz.com.cn/html/2024/202405201406.shtml'
        },
        {
          imgUrl: '//video.cnxz.com.cn/UpLoadFiles/image/20240520/20240520151252445244.png',
          title: '感受人文荟萃 山水相依的徐..',
          jumpLink: 'http://video.cnxz.com.cn/html/2024/202405201405.shtml'
        },
        {
          imgUrl: '//video.cnxz.com.cn/UpLoadFiles/image/20240520/20240520150774037403.png',
          title: '徐州已经等了你几千年',
          jumpLink: 'http://video.cnxz.com.cn/html/2024/202405201404.shtml'
        },
        {
          imgUrl: '//video.cnxz.com.cn/UpLoadFiles/image/20240520/20240520150590289028.png',
          title: '百年煤城”变身“淮海明珠..',
          jumpLink: 'http://video.cnxz.com.cn/html/2024/202405201403.shtml'
        }
      ],
      intervalId: ''
    }
  },
  // components: {
  // 	Swiper,
  // 	SwiperSlide,
  // },
  mounted() {
    this.showGray();
    this.getData();
    this.intervalId = setInterval(this.scroll, 3500) // 间隔时间后重复执行
  },
  methods: {
    showGray(){ //置灰
       showGray({}).then(res => {
          this.showFilter=res.data.showGray;
      })
    },
    goRouter(id) {
      let tabData = [
        { name: '首页', id: null, linkUrl: '/', route: '' },
        { name: '时政要闻', id: '11', linkUrl: '', route: '' },
        { name: '徐州新闻', id: '1', linkUrl: '', route: '' },
        { name: '县域新闻', id: '19', linkUrl: '/countyLevel', route: '' },
        { name: '徐州发布', id: null, linkUrl: 'https://www.xuzhoufabu.com/', route: '' },
        { name: '徐州网视', id: null, linkUrl: 'https://video.cnxz.com.cn/', route: '' },
        { name: '彭城e评', id: '6', linkUrl: '', route: '' },
        { name: '网罗天下', id: '10', linkUrl: '', route: '' },
        { name: '安全生产', id: '47', linkUrl: '', route: '' },
        { name: '法律援助', id: '61', linkUrl: '', route: '' },
        { name: '健康生活', id: '3', linkUrl: '', route: '' },
        { name: '热点专题', id: null, linkUrl: '/topic', route: '' }
      ]
      let t = tabData.findIndex(function (item) {
        return item.id == id;
      })
      if (tabData[t].linkUrl) {
        window.open(tabData[t].linkUrl + '?tab=' + t, "_blank");
      } else {
        window.open('/importNews?id=' + id + '&tab=' + t, "_blank");
      }
    },
    gofabuIm(){
      window.open('/importNews?id=50');
    },
    goFabu(item, index) {
      console.log(item);
      // return;
      if (index == 0) {
        window.open('https://www.xuzhoufabu.com/videoDetail?id=' + item.id, "_blank");
      } else {
        window.open('/newsDetail?DetailId=' + item.id, "_blank");
      }
    },
    goXuZ(columnName){
       if(columnName=='徐州发布'){
        window.open('https://www.xuzhoufabu.com', "_blank");
       }else{
        window.open('/importNews?id=1833803344738340864'+'&tab=5', "_blank");
       }
    },
    goImport() {
      window.open('/importNews?id=11&tab=1', "_blank");
    },
    getData() {
      // 专题
      topTopic({}).then(res => {
        this.topicData = res.data;
      })
      // 首页数字报图片和链接
      indexPaper({}).then(res => {
        this.shuzi = res.data;
      })
      // 顶部轮播图
      indexAdList({}).then(res => {
        this.bannerData = res.data;
      })
      // 底部链接
      friendshipLinkList({}).then(res => {
        this.friendshipLink = res.data;
      })
      indexNews({}).then(res => {
        this.indexTopList = res.data;
        this.bannerDataList = this.indexTopList.todayTop;
      })
      indexColumnNews({}).then(res => {
        this.columnNewData = res.data;
      })
      otherNews({}).then(res => {
        this.otherNewsData = res.data;
      })

    },
    goDetail(url, name) {
      window.open(url + '?name=' + name, "_blank");
    },
    goDetailNew(item) {
      if (item.articleType == 1) {
        window.open('/newsDetail?DetailId=' + item.id, "_blank");
      } else {
        window.open(item.jumpLink, "_blank");
      }
    },
    // 定义动画
    scroll() {
      const con1 = this.$refs.bannerL;
      con1.className = 'bannerAnmil';
      setTimeout(() => {
        let dataItem = this.bannerDataList[0];
        this.bannerDataList.shift(0);
        con1.className = '';
        this.bannerDataList.push(dataItem)
      }, 1800)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.htmlFilter {
  filter:grayscale(100%);
  -webkit-filter:grayscale(100%);
  -moz-filter:grayscale(100%);
  -ms-filter:grayscale(100%);
  -o-filter:grayscale(100%);
  filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter:grayscale(1)
}
.enterZ{
  text-align: center;
  margin-bottom: 25px;
}
.bannerAnmil {
  animation-name: scrollText;
  animation-duration: 2s;
  // background: red;
}

@keyframes scrollText {
  0% {
    margin-top: 0;
  }

  100% {
    margin-top: -70px;
  }
}

@-webkit-keyframes scrollText {
  0% {
    margin-top: 0;
  }

  100% {
    margin-top: -70px;
  }
}

@-moz-keyframes scrollText {
  0% {
    margin-top: 0;
  }

  100% {
    margin-top: -70px;
  }
}

.inde_img1 {
  display: flex;
  justify-content: space-between;
}

.import_tit_1 {
  display: flex;
  align-items: center;
  min-height: 100px;
  justify-content: space-between;

  a {
    flex: 1;
    margin: 20px 0;
    color: #245488;
    font-weight: bold;
    letter-spacing: 2px;
    line-height: 58px;
    font-size: 44px;
    text-align: center;
    margin-right: 20px;
    cursor: pointer;

    span {
      position: relative;

      &:hover {
        border-bottom: 2px solid #245488;
      }
    }
  }

  p {
    span {
      font-size: 13.5px;
      padding: 5px 2px;
      letter-spacing: 2px;
      cursor: pointer;
      background: #245488;
      color: #fff;
      writing-mode: tb-rl;
    }

    // flex-direction: column;
  }
}

.import_tit_2 {
  margin: 4px 0;
  color: #686B6C;
  text-align: center;

  a {
    display: inline-block;
    cursor: pointer;
    margin: 4px 10px;

    &:hover {
      position: relative;

      &::after {
        content: "";
        width: 100%;
        height: 1px;
        background: #686B6C;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }

  }
}

// banner
.banner {
  margin: 26px 0 10px 0;
  display: flex;
  justify-content: space-between;

  .banner_l {
    width: 780px;
    margin-right: 26px;

    &_tit {
      height: 70px;
      line-height: 70px;
      overflow: hidden;
      text-align: center;
      color: #245488;
      font-weight: bold;
      cursor: pointer;
      font-size: 24px;
      letter-spacing: 2px;
      background: #F3F3F3;
      margin-bottom: 20px;

      ul {}

      li {
        color: #245488;

        &:hover {
          // background: #e9e6e6;
        }
      }
    }

    .overf {
      padding: 0 20px;
    }
  }

  .banner_r {
    flex: 1;
    min-width: 0;

    &_p {
      //height: 70px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;

      img {
        cursor: pointer;
      }
    }

  }
}

/deep/.banner_car {
  width: 100%;
  height: 380px;
  position: relative;

  .el-carousel__container {
    height: 380px;
  }

  .banner_car_tit {
    position: absolute;
    height: 44px;
    line-height: 44px;
    letter-spacing: 1px;
    bottom: 0;
    left: 0;
    right: 0;
    cursor: pointer;
    padding: 0 120px 0 20px;
    font-size: 19px;
    color: #fff;
    background: rgba($color: #000000, $alpha: 0.5);
  }

  img {
    height: 380px;
  }

  .el-carousel__arrow {
    background: rgba(31, 45, 61, .4);
  }

  .el-carousel__indicators--horizontal {
    left: auto;
    right: 10px;
    transform: translateX(0);

    .el-carousel__indicator--horizontal {
      .el-carousel__button {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        opacity: 1;
        background: rgba($color: #fff, $alpha: 0.5);
      }
    }

    .is-active {
      .el-carousel__button {
        background: #E00001;
      }

    }
  }
}

// 内容
.news_r_tit {
  margin: 10px 0 10px 0;
}

.news {
  // margin-top: 20px;
  display: flex;
  justify-content: space-between;

  .news_content {
    width: 780px;

    .new_ul {
      p {
        margin: 26px 0 20px 0;
        color: #E00001;
        cursor: pointer;
        padding-left: 10px;
        font-size: 18px;
        font-weight: bold;
        position: relative;
        display: inline-block;

        &:hover {
          position: relative;

          &::after {
            content: ' ';
            position: absolute;
            left: 10px;
            right: 0;
            height: 1px;
            bottom: 0;
            background: #E00001;
          }
        }

        &::before {
          content: "";
          width: 4px;
          height: 80%;
          background: #E00001;
          position: absolute;
          left: 0;
          top: 10%;
        }
      }

      margin: 0px 10px 10px 0;
      display: inline-block;
      width: 360px;
    }
  }

  .news_r {
    flex: 1;
    overflow: hidden;
    margin-top: 10px;

    .new_r_card {
      background: #F9F9F9;
      padding: 10px;
      cursor: pointer;

      img {
        max-width: 100%;
      }
    }

    .new_r_cards {
      padding-bottom: 0;
      // height:468px;
      height: 224px;
      position: relative;
      overflow: hidden;

      &::after {
        content: '';
        height: 10px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        background: #F9F9F9;
      }
    }

    .new_r_shu {
      display: flex;
      justify-content: space-between;
      text-align: center;
      font-size: 14px;

      img {
        width: 163px;
        height: 246px;
        object-fit: fill;
      }

      a {
        text-decoration: none;
        flex: 1;
        text-align: center;
      }

      span {
        color: #333639;

        &:hover {
          border-bottom: 1px solid #333639;
          // font-weight: bold;
        }

      }
    }

    .share_self {
      overflow: hidden;
    }

  }
}

// 专题列表
.topic {
  background: url('http://hfy-img.xzyunchuang.com/eb6d6cdb73b1ca2615d42f25193462f4');
  background-size: 100% 100%;
  height: 240px;
  width: 1170px;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .topicImg {
    margin: 0 29px 0 18px;
    width: 40px;

  }

  .topicList {
    width: 1160px;
    //  overflow: hidden;
    //  padding-right: 14px;
  }
}

// 视频列表
.videoList {
  p {
    height: 4px;
    margin: 40px 0 30px 0;
    background: #eee;
    position: relative;
    color: #245488;
    font-weight: bold;
    font-size: 18px;

    // letter-spacing: 2px;
    span {
      position: absolute;
      left: 20px;
      top: -10px;
      background: #fff;
      padding: 0 16px;
      line-height: 20px;
      cursor: pointer;
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
  }

  li {
    width: 280px;
    position: relative;
    background: #F9F9F9;
    border-radius: 0 0 4px 4px;
    // margin-bottom: 20px;
    color: #333639;

    a {
      color: #333639;
    }

    cursor: pointer;

    &:not(:nth-child(4n)) {
      margin-right: 15px;
    }

    img {
      width: 280px;
      height: 160px;
      border-radius: 4px 4px 0 0;
    }

    .videoPlay {
      position: absolute;
      left: 125px;
      top: 65px;
      width: 30px;
      height: 30px;
    }

    span {
      display: inline-block;
      padding: 10px 20px;
      line-height: 22px;
      width: calc(100% - 40px);

      &:hover {
        color: #245488;
      }
    }
  }
}

.wxBg {
  background: #F9F9F9;
  padding: 10px 0;
  margin-top: 30px;
  min-height: 100px;

  .codeTit {
    text-align: center;
    color: #333639;
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 30px 0;
    letter-spacing: 1px;
  }

  .code_list {
    margin: 20px 0 30px 0;
    display: flex;
    justify-content: space-between;

    &_1 {
      display: flex;
      font-size: 14px;

      img {
        width: 70px;
        height: 70px;
        margin-right: 10px;
      }

      div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        span {
          display: block;
        }
      }
    }
  }
}

.onlineBg {
  background: #333;
  padding: 30px;

  .pageW {
    display: flex;
    justify-content: space-between;

    .online_c {
      color: #fff;
      font-size: 13px;
      line-height: 26px;

      a {
        cursor: pointer;
        color: #fff;
        text-decoration: none;

        &:hover {
          position: relative;

          &::after {
            content: " ";
            height: 1px;
            background: #fff;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
          }
        }
      }

      &:not(:last-child) {
        span {
          // background: gold;
          display: inline-block;
          width: 80px;
          margin-right: 10px;
        }

        position: relative;
        margin-right: 34px;

        &::after {
          content: " ";
          width: 2px;
          height: 100%;
          background: #242424;
          position: absolute;
          top: 0;
          right: 0;

        }
      }

      &:first-child {
        width: 370px;
      }

      &:nth-child(2) {
        flex: 1;
      }

      &:last-child {
        width: 170px;

        span {
          display: block;
        }
      }
    }
  }

  p {
    color: #E00001;
    margin-bottom: 10px;
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue